import { Grid } from '@mui/material';
import { ReactNode } from 'react';

export const DialogHeader = ({
  children,
  additionalSx,
}: {
  children: ReactNode;
  additionalSx?: object;
}) => {
  return (
    <Grid
      sx={[
        {
          padding: '40px 40px 20px 40px',
          borderRadius: '12px 12px 0px 0px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          borderBottom: '1px solid #F3F4F9',
        },
        additionalSx,
      ]}
    >
      {children}
    </Grid>
  );
};
